<div *ngIf="!errorMessage" class="placeholder"></div>
<div class="invalid-feedback d-block" *ngIf="errorMessage">{{ 'VALIDATIONS.' + errorMessage?.message | translate:errorMessage }}</div>
